var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { format } from "date-fns";
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
const t = getObservableT("patients");
export class PatientConsentUseExistingRecordsViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    get lastAccessedDate() {
        var _a;
        const asOf = (_a = this.patientConsentUIManager.existingRetrievalLastUpdatedAt) !== null && _a !== void 0 ? _a : new Date();
        return format(asOf, "LLL d, yyyy");
    }
    get title() {
        return this.isHealthWalletEnabled
            ? t("Your HealthEx Wallet Was Last Updated on {{ date }}", { date: this.lastAccessedDate })
            : t("Is your HealthEx Unified Record up to date?");
    }
    get keepExistingRecordsButtonText() {
        return t("Keep Existing Records");
    }
    get refreshRecordsButtonText() {
        return t("Refresh Records");
    }
    async useExistingRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(false);
        await this.patientConsentUIManager.reuseExistingRecords();
        this.goToNextPage();
    }
    lookForUpdatedRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(true);
        this.goToNextPage();
    }
}
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "lastAccessedDate", null);
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "title", null);
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "keepExistingRecordsButtonText", null);
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "refreshRecordsButtonText", null);
